import { render, staticRenderFns } from "./generallistCategories.vue?vue&type=template&id=aa06658e&scoped=true"
import script from "./generallistCategories.vue?vue&type=script&lang=js"
export * from "./generallistCategories.vue?vue&type=script&lang=js"
import style0 from "./generallistCategories.vue?vue&type=style&index=0&id=aa06658e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa06658e",
  null
  
)

export default component.exports